(function (angular) {
    'use strict';

    angular.module('chat2')

        /**
         * 
         */
        .config(['$stateProvider', function ($stateProvider) {

            /**
             * 
             * @param {*} error 
             */
            function handleError($q, error) {
                var deferred = $q.defer();
                if (error.status === 404) {
                    deferred.resolve(null);
                } else if (error.status < 500) {
                    deferred.resolve(error.data ? error.data : error);
                } else {
                    deferred.reject(error);
                }
                return deferred.promise;
            }

            /**
             * Start Chat routing requires query store profile as that contains
             * @param {*} profilesService 
             * @param {*} apiSpaceId 
             * @param {*} profileId 
             * @param {*} usePrimary 
             */
            function getProfile(profilesService, apiSpaceId, profileId, usePrimary) {
                return usePrimary === true ? profilesService.getProfileDirect(apiSpaceId, profileId) : profilesService.getProfile(apiSpaceId, profileId);
            }

            function getParticipantProfileId(participants) {
                var profileId = null;
                angular.forEach(participants, function (participant) {
                    if (participant.role === "participant") {
                        profileId = participant.id;
                    }
                });
                return profileId;
            }

            /**
             * Returns a profile - if this is linked, it returns  the primary
             * @param {*}  
             * @param {*} profilesService 
             * @param {*} apiSpaceId 
             * @param {*} profileId 
             * @returns {object}  {profile: object, islinked: boolean}
             */
            function getParticipantProfile($q, profileTemplateService, profilesService, profileHelper, apiSpaceId, profileId, usePrimary) {

                var _profile;
                return getProfile(profilesService, apiSpaceId, profileId, usePrimary)
                    .then(function (result) {
                        if (result && result._relationships && result._relationships.primaryId) {
                            return getProfile(profilesService, apiSpaceId, result._relationships.primaryId, usePrimary)
                                .then(function (parentProfile) {
                                    return parentProfile;
                                }).catch(function (error) {
                                    return handleError($q, error);
                                });
                        } else {
                            return result;
                        }
                    })
                    .then(function (result) {
                        _profile = result || {};
                        return profileTemplateService.getProfileTemplate(apiSpaceId);
                    })
                    .then(function (profileTemplate) {
                        var result = {
                            profile: profileHelper.buildProfile(_profile, profileTemplate),
                            isLinked: !!_profile._relationships,
                            // These two will only be there if requiresQuery was set to true!!!!
                            _devices: _profile._devices,
                            _sessions: _profile._sessions
                        };
                        return result;
                    })
                    .catch(function (error) {
                        return handleError($q, error);
                    });
            }


            $stateProvider
                /**
                 *
                 */
                .state('main.apiSpace.chat2', {
                    url: '/chat2',
                    templateUrl: 'components/toolkit/chat/templates/chat.html',
                    authenticate: true,
                })
                .state({
                    name: 'main.apiSpace.chat2.chat',
                    url: '/conversations?scope&filter&teamId',
                    authenticate: true,
                    templateUrl: 'components/toolkit/chat/templates/chatView.html',
                    controller: 'chat2Ctrl',
                    resolve: {
                        profileTemplate: ['$q', '$stateParams', 'profileTemplateService', function ($q, $stateParams, profileTemplateService) {
                            return profileTemplateService.getProfileTemplate($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (error) {
                                    return handleError($q, error);
                                });
                        }],
                        presence: ['$q', 'chatPresenceService', 'jwtService', '$stateParams', function ($q, chatPresenceService, jwtService, $stateParams) {
                            return chatPresenceService.getPlatformUserPresence($stateParams.pickedApiSpaceId, jwtService.payload.sub)
                                .then(function (response) {
                                    return $q.resolve();
                                })
                                .catch(function (error) {
                                    console.error(error);
                                    return $q.resolve();
                                });
                        }],
                        teams: ["$q", "$stateParams", "teamSettingsService", "sharedChatDataService",
                            function ($q, $stateParams, teamSettingsService, sharedChatDataService) {
                                return teamSettingsService.getTeams($stateParams.pickedApiSpaceId)
                                    .then(function (teams) {
                                        sharedChatDataService.teams = teams;
                                        return $q.resolve(teams);
                                    });
                            }],
                        conversations: ["$q", "$filter", "sharedDataService", "comapiChatService", "$stateParams", "$state", "permissionService", "teams",
                            function ($q, $filter, sharedDataService, comapiChatService, $stateParams, $state, permissionService, teams) {

                                // need to check permissions for these ...
                                // scope = [profile|all]
                                // filter = [open|new|replied|closed]

                                // 1) check the options are correct and default if not ...
                                var scopes = ["profile", "all"];
                                var filterOptions = ["open", "new", "replied", "closed"];

                                if ($stateParams.scope === "all" && permissionService.checkPermission("chat:ra") !== true) {
                                    $stateParams.scope = "profile";
                                }

                                if (scopes.indexOf($stateParams.scope) === -1) {
                                    $stateParams.scope = "profile";
                                }

                                if (filterOptions.indexOf($stateParams.filter) === -1) {
                                    $stateParams.filter = "open";
                                }

                                if ($stateParams.teamId) {
                                    // check this team exits ...
                                    var found = teams.filter(function (t) {
                                        return t.id === $stateParams.teamId;
                                    });

                                    if (found.length === 0) {
                                        $stateParams.teamId = undefined;
                                    }
                                }
                                sharedDataService.spinning = true;

                                return comapiChatService.ready()
                                    .then(function (result) {
                                        return comapiChatService.getConversations($stateParams.scope, $stateParams.filter);
                                    })
                                    .then(function (conversations) {
                                        sharedDataService.spinning = false;

                                        if ($state.toParams.id === undefined && conversations.length > 0) {
                                            console.warn("redirect to first conversation");

                                            var filtered = $filter('chat2Filter')(conversations, $stateParams.filter, $stateParams.scope, $stateParams.teamId);

                                            if (filtered.length > 0) {
                                                var error = {};
                                                error.redirectTo = "main.apiSpace.chat2.chat.conversation";
                                                error.redirectToParams = {
                                                    pickedApiSpaceId: $stateParams.pickedApiSpaceId,
                                                    id: filtered[0].id,
                                                    scope: $stateParams.scope,
                                                    filter: $stateParams.filter,
                                                    teamId: $stateParams.teamId
                                                }
                                                return $q.reject(error);
                                            }
                                            else {
                                                return $q.resolve(filtered);
                                            }

                                        } else {
                                            return $q.resolve(conversations);
                                        }
                                    })
                                    .catch(function (error) {
                                        sharedDataService.spinning = false;
                                        throw error;
                                    });
                            }],
                    },
                })
                .state('main.apiSpace.chat2.chat.conversation', {
                    url: '/{id}',
                    views: {
                        conversation: {
                            templateUrl: "components/toolkit/chat/templates/conversationView.html",
                            controller: "chatConversationCtrl"
                        },
                        profile: {
                            templateUrl: 'components/toolkit/chat/templates/profileView.html',
                            controller: 'participantProfileCtrl',
                        }
                    },
                    params: {
                        criteria: null,
                        sorting: null,
                        pickedCriteria: null
                    },
                    resolve: {
                        conversationInfo: ["$q", "$stateParams", "comapiChatService", "conversations",
                            function ($q, $stateParams, comapiChatService, conversations) {

                                return comapiChatService.getConversationInfo($stateParams.id)
                                    .then(function (conversationInfo) {
                                        return conversationInfo;
                                    }).catch(function (error) {
                                        console.error("getConversationInfo() failed", error);
                                        error.redirectTo = "error";
                                        return $q.reject(error);
                                    });
                            }],
                        teamConfig: ["$q", "teamSettingsService", "$stateParams", "conversationInfo",
                            function ($q, teamSettingsService, $stateParams, conversationInfo) {
                                return teamSettingsService.getChatConfig($stateParams.pickedApiSpaceId, conversationInfo.conversation.teamId)
                                    .then(function (result) {
                                        var team = result.teams.find(function (t) { return t.teamId === conversationInfo.conversation.teamId });

                                        if (team) {
                                            return $q.resolve(team);
                                        } else {
                                            console.error("Couldn't find team " + conversationInfo.conversation.teamId, result.teams);
                                            return $q.resolve({});
                                        }
                                    });
                            }],
                        // TODO: Need to introduce some caching fo this
                        teamAvatar: ["$q", "teamConfig",
                            function ($q, teamConfig) {
                                return teamConfig && teamConfig.settings && teamConfig.settings.avatarUrl ? $q.resolve(teamConfig.settings.avatarUrl) : $q.resolve("./assets/img/icons/syg.png");
                            }],
                        participantProfileId: ["conversationInfo", "sharedChatDataService",
                            function (conversationInfo, sharedChatDataService) {
                                var profileId = getParticipantProfileId(conversationInfo.conversation.participants);

                                if (!profileId) {
                                    profileId = getParticipantProfileId(conversationInfo.participants);
                                }

                                if (profileId) {
                                    sharedChatDataService.participantProfileId = profileId;
                                }

                                return profileId;
                            }],
                        participantProfile: ['$q', 'profileTemplateService', 'profilesService', 'profileHelper', '$stateParams', 'conversationInfo', 'participantProfileId',
                            function ($q, profileTemplateService, profilesService, profileHelper, $stateParams, conversationInfo, participantProfileId) {
                                return getParticipantProfile($q, profileTemplateService, profilesService, profileHelper, $stateParams.pickedApiSpaceId, participantProfileId, true);
                            }],
                        formTemplates: ['$q', 'formService', '$stateParams', 'permissionService',
                            function ($q, formService, $stateParams, permissionService) {
                                if (permissionService.checkPermission('frm:tmpl:r')) {
                                    return formService.getFormTemplates($stateParams.pickedApiSpaceId)
                                        .then(function (result) {
                                            return result;
                                        }).catch(function (error) {
                                            return handleError($q, error);
                                        });
                                }
                            }],
                    },
                    authenticate: true
                })
                .state({
                    name: 'main.apiSpace.chat2.settings',
                    url: '/settings',
                    templateUrl: 'components/toolkit/chat/templates/settingsView.html',
                    controller: 'chatSettingsCtrl',
                    authenticate: true,
                })
                .state({
                    name: 'main.apiSpace.chat2.settings.team',
                    url: '/{teamId}',
                    templateUrl: 'components/toolkit/chat/templates/teamDetailsView.html',
                    controller: 'TeamDetailsCtrl',
                    authenticate: true,
                    resolve: {
                        team: ["teamSettingsService", "$state", "$q", function (teamSettingsService, $state, $q) {
                            return teamSettingsService.getTeam($state.toParams.pickedApiSpaceId, $state.toParams.teamId)
                                .then(function (data) {
                                    return data;
                                })
                                .catch(
                                    function (error) {
                                        if (error.status === 404) {
                                            error.redirectTo = "main.apiSpace.chat2.settings";
                                            error.redirectToParams = { pickedApiSpaceId: $state.toParams.pickedApiSpaceId };
                                            return $q.reject(error);
                                        }
                                    });
                        }],
                        chatConfig: ["teamSettingsService", "$state", "$q", function (teamSettingsService, $state, $q) {
                            return teamSettingsService.getChatConfig($state.toParams.pickedApiSpaceId)
                                .then(function (data) {
                                    return data;
                                })
                                .catch(
                                    function (error) {
                                        if (error.status === 404) {
                                            return $q.resolve({});
                                        } else {
                                            return $q.reject(error);
                                        }
                                    });
                        }],

                    }
                })
                .state('main.apiSpace.chat2.chat.start', {
                    url: '/start/{profileId}',
                    authenticate: true,
                    views: {
                        conversation: {
                            templateUrl: "components/toolkit/chat/templates/startChatView.html",
                            controller: "startChatCtrl"
                        },
                        profile: {
                            templateUrl: 'components/toolkit/chat/templates/profileView.html',
                            controller: 'participantProfileCtrl',
                        }
                    },
                    resolve: {
                        participantProfile: ['$q', 'profileTemplateService', 'profilesService', 'profileHelper', '$stateParams',
                            function ($q, profileTemplateService, profilesService, profileHelper, $stateParams) {
                                // calling the query version of this method (true on the end)
                                return getParticipantProfile($q, profileTemplateService, profilesService, profileHelper, $stateParams.pickedApiSpaceId, $stateParams.profileId, false);
                            }],
                        teamAvatar: [function () {
                            return undefined;
                        }],
                        conversationInfo: function () {
                            return {};
                        }
                    }
                })

        }]);

})(window.angular);
